import { render, staticRenderFns } from "./KitchenDrawer.vue?vue&type=template&id=573af6ae&scoped=true&"
import script from "./KitchenDrawer.vue?vue&type=script&setup=true&lang=js&"
export * from "./KitchenDrawer.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./KitchenDrawer.vue?vue&type=style&index=0&id=573af6ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573af6ae",
  null
  
)

export default component.exports